<template>
  <div class="margin-general account-tailored">
    <div class="titel-descript">
      <h2 v-html="$t(title)"></h2>
      <p class="body-4" v-html="formatContent(description, $t, localPath)"></p>
      <p class="body-4" v-html="formatContent(description2, $t, localPath)"></p>
      <div class="buttons" v-if="name_btn">
        <NuxtLink
          class="second-button-small"
          :to="localPath(name_btn_url)"
          >{{ textBTn }}</NuxtLink
        >
      </div>
      <div class="buttons" v-if="btn_suscribe">
        <NuxtLink
          target="_blank"
          class="primary-button-medium"
          :to="btn_suscribe_url"
          >{{ btn_suscribe_text }}</NuxtLink
        >
      </div>
    </div>
    <div class="items-cont">
      <div v-for="item in items" :key="item.id" class="item">
        <span class="material-symbols-outlined" translate="no">{{ item.icon }}</span>
        <div class="descript-cont">
          <div class="title-descript" v-if="item.titledescription">
            <p class="body-6-bold">{{ $t(item.titledescription) }}</p>
          </div>
          <p class="body-4">{{ $t(item.description) }}</p>
        </div>
      </div>
    </div>

    <div class="buttons-2" v-if="btn_suscribe">
      <NuxtLink
        target="_blank"
        class="primary-button-medium"
        :to="btn_suscribe_url"
        >{{ btn_suscribe_text }}</NuxtLink
      >
    </div>
    <div class="buttons-2" v-if="name_btn">
      <NuxtLink
        class="second-button-small"
        :to="localPath(name_btn_url)"
        >{{ textBTn }}</NuxtLink
      >
    </div>
  </div>
</template>

<script setup>
import { formatContent } from '~/utils/formatContent';

const localPath = useLocalePath();
const props = defineProps({
  title: String,
  description: String,
  description2: String,
  name_btn: Boolean,
  name_btn_url: String, 
  textBTn: String,
  btn_suscribe: Boolean,
  btn_suscribe_text: String, 
  btn_suscribe_url: String,
  items: Array,
});
</script>